/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudWireIcon20Light = forwardRef('NetCloudWireIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 15H5.25a4.625 4.625 0 0 1-1.205-9.056 5.126 5.126 0 0 1 9.747-1.44A5.25 5.25 0 1 1 14 15h-4v3h5.5a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1H9v-3ZM5.008 6.371a4.125 4.125 0 0 1 7.99-1.169.5.5 0 0 0 .525.324A4.25 4.25 0 1 1 14 14H5.293a3.625 3.625 0 0 1-.68-7.17.5.5 0 0 0 .395-.459Z" })));
});
